import { render, staticRenderFns } from "./OrderSettingForm.vue?vue&type=template&id=516e69bf&"
import script from "./OrderSettingForm.vue?vue&type=script&lang=js&"
export * from "./OrderSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports